var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfectivo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "26px",
    viewBox: "0 0 33 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5.2 Efectivo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.9Reservaciones-Copy-2",
    transform: "translate(-85.000000, -775.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(68.000000, 715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-8",
    transform: "translate(0.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.2-Efectivo",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9691,10.319 C15.0651,9.944 15.0651,9.803 15.0651,9.666 C15.0651,9.449 15.2611,9.324 15.6021,9.324 C16.1221,9.324 16.4351,9.504 16.5861,9.59 L17.0941,9.882 L17.6971,8.293 L17.3331,8.079 C17.0221,7.897 16.6831,7.777 16.3071,7.715 L16.3071,6.719 L14.7011,6.719 L14.7011,7.817 C13.8021,8.117 13.2231,8.866 13.2231,9.783 C13.2231,11.018 14.2001,11.567 15.1501,11.939 C15.9441,12.261 15.9441,12.498 15.9441,12.64 C15.9441,12.979 15.5861,13.099 15.2791,13.099 C14.8861,13.099 14.4631,12.973 14.1481,12.763 L13.6151,12.407 L13.0371,14.021 L13.3441,14.241 C13.6731,14.475 14.1391,14.647 14.6331,14.723 L14.6331,15.753 L16.2491,15.753 L16.2491,14.627 C17.1891,14.316 17.7951,13.532 17.7951,12.572 C17.7951,11.235 16.8181,10.665 15.9691,10.319",
    id: "Fill-1",
    fill: "#FE8D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20.478 L0,2.748 C0,1.23 1.23,0 2.748,0 L28.183,0 C29.7,0 30.93,1.23 30.93,2.748 L30.93,20.478 C30.93,21.995 29.7,23.226 28.183,23.226 L2.748,23.226 C1.23,23.226 0,21.995 0,20.478 Z",
    id: "Stroke-3",
    stroke: "#FE8D27",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9301,17.347 L26.9301,5.879 C25.8921,5.879 25.0511,5.038 25.0511,4 L5.8791,4 C5.8791,5.038 5.0381,5.879 4.0001,5.879 L4.0001,17.347 C5.0381,17.347 5.8791,18.188 5.8791,19.226 L25.0511,19.226 C25.0511,18.188 25.8921,17.347 26.9301,17.347 Z",
    id: "Stroke-5",
    stroke: "#FE8D27",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfectivo);
export default __webpack_public_path__ + "static/media/Efectivo.b61a2a3ac777627176e757f8293a35c9.svg";
export { ForwardRef as ReactComponent };